import { render, staticRenderFns } from "./ChartsView.vue?vue&type=template&id=5c397a76&scoped=true&"
import script from "./ChartsView.vue?vue&type=script&lang=ts&"
export * from "./ChartsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c397a76",
  null
  
)

export default component.exports